/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class connectionparameters extends IceEntity {
  connection_parameters_key: string = "";
  connection_title: string = "";
  trans_account: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  application_code: string = "";
  server_user_name;
  server_password: string = "";;
  ip: string = "";;
  folder: string = "";;
  root_name: string = "";;
  encryption_user_id: string = "";;
  multipart_variables: string = "";;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  gettablename(): string {
    return "CONNECTION_PARAMETERS";
  }
}
